import InactiveAccount from '@auth/InactiveAccount'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/login/inactive')({
  component: RouteComponent,
  validateSearch: z.object({
    to: z.string().optional(),
  }),
})

function RouteComponent() {
  const { to } = Route.useSearch()

  return <InactiveAccount to={to} />
}
